<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
  <div class="card-block" style="margin-left: 20px; margin-right: -12px;">
    <div class="head-block-title">
      <div class="row">
        <div class="col-md-8">
          <span class="listHeaderText">Receipt ({{paymentListData?.length}})</span>
        </div>
        <div class="col-md-4 d-flex" style="justify-content: flex-end;">
          <button class="btn btn-primary d-flex align-items-center" (click)="changeAddUpdateModalState()">
            <img src="../../../../assets/images/addicon.svg" aria-hidden="true" class="icon-img">
            <span class="add-btn-text"> Add</span>
          </button> &nbsp; &nbsp;
          <export [showIconOnly]="false" [data]="selectedExportData"></export>
        </div>
      </div>
    </div>
    <div class="main-field">
      <div class="main-block-content">
        <div class="table-container">
          <app-common-table-dark [columnDefs]="columnDefs" [data]="paymentListData"
            (commonDropdownChange)="onCommonTableDropdownChange($event)"
            (selectedRowsChange)="onSelectedRowsChange($event)">
          </app-common-table-dark>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Card Starts for mobile screen -->
<div class="content-area">
  <span class="listHeaderText">Payments ({{paymentListData?.length}})</span>
  <div class="row subHeaderButtonDiv">
    <div class="col-md-6 export-div">
      <export [showUI]="true" [showIconOnly]="false" [data]="paymentListData"></export>
    </div>
    <div class="col-md-6 d-flex" class="positioned-flex">
      <button class="btn btn-primary closeModal d-flex align-items-center" (click)="showModal()">
        <img src="../../../../assets/images/addicon.svg" aria-hidden="true" class="icon-img">
        <span class="add-btn-text"> Add</span>
      </button>
    </div>
  </div>

  <!--Export Modal-->
  <div class="modal export-modal" [ngClass]="showExport ? 'booking-modal-show':'booking-modal-hide'" tabindex="-1"
    role="dialog" aria-labelledby="myLargeModalLabel">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <app-export-list (exportValues)="exportValues($event)" (hideModal)="hideExport()" style="height: 59vh;"
          [exportType]="exportSelectedType" [dataList]="paymentListData" [rowSelection]="'multiple'"
          [fileName]="clientfileName" [exportColumnKeys]="columnKeys" [submitButtonTitle]="'Export'"
          [headerName]="'Payment List'"></app-export-list>
      </div>
    </div>
  </div>
  <div class="mb-2 mr-2">
    <div class="row">
      <div class="col-md-12">
        <span>
          <input type="search" class="form-control inputSearch" placeholder="Search Payment" [(ngModel)]="filterTerm">
        </span>
      </div>
    </div>
  </div>
  <div class="row row-cards-one">
    <div class="col-md-12 col-lg-3 col-xl-3">
      <div class="mycard bg1" *ngFor="let payment of paymentListData | filter: filterTerm">
        <div class="left">
          <tr>
            <td class="card-row">
              <b><i class="fa fa-user" aria-hidden="true" style="margin-bottom: 10px;">
                </i> {{payment?.clientName}}</b><br>
              <b><i aria-hidden="true" style="margin-bottom: 10px;">
                </i> {{payment?.allocationType}}</b><br>
              <b><img src="../../../../assets/images/transaction icon.svg" alt="" height="20" width="15">
                {{payment.transactionNumber}}</b><br>
              <b><i class="fa fa-inr" aria-hidden="true" style="margin-bottom: 10px;">
                </i> {{payment?.amount}}</b>
            </td>
          </tr>
        </div>
        <div class="right d-flex align-self-center">
          <tr>
            <td class="card-row">
              <div class="dropdownMenu" (click)="dropdownActonMenu(payment.id)" style="display: block;">
                <div>
                  <img src="assets/images/Action icon red.svg" alt="">
                </div>
                <div class="dropdownMenu-content dropdownActionMenu" id="actionMenuContent{{payment.id}}"
                  *ngIf="ActionList" style="top: 24px; left: -12vh;">

                  <span *ngIf="payment.allocationType == 'Booking'" class="dropdownMenu-content-option"
                    (click)="routeBookingPage(payment)"><img [src]="bookingIcon" alt="Booking Icon"
                      class="icon-img" />Booking</span>
                  <span *ngIf="payment.allocationType == 'Allotment'" class="dropdownMenu-content-option"
                    (click)="routeAllotmentPage(payment)"><img [src]="allotmentIcon" alt="Allotment Icon"
                      class="icon-img" />Allotment</span>
                  <span class="dropdownMenu-content-option" (click)="changeAddUpdateModalState(payment)"><img
                      [src]="editIcon" alt="Edit Icon" class="icon-img" />Edit</span>
                </div>
              </div><br>
              <b><img src="../../../../assets/images/Cards Icon.svg" alt="" height="20" width="20">
                {{payment?.paymentType}}</b><br>
              <b><i class="fa fa-calendar" aria-hidden="true" style="margin-bottom: 10px;">
                </i> {{payment?.paymentDate }}</b>
              <br>
            </td>
          </tr>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Documents -->
<div class="modal fade drawer right-align" [ngClass]="isDocument?'drawer show right-align':'payment-modal-hide hide'"
  id="documentRightgDrawer" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" >
        <h5 class="modal-title" id="document">Documents</h5>
        <button type="button" id="document" class="close" data-dismiss="modal" aria-label="Close" (click)="Close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <app-documents [documentsData]="picData"></app-documents>

    </div>
  </div>
</div>



